import * as actionType from "../types/ActionTypes";

const initialState = {
  level: [],
  postLevel: [],
  error: false,
  isLoading: false,
  isPostLoading: false,
  isUpdateLoading: false,
};

export const Level = (state = initialState, action) => {
  switch (action.type) {
    case actionType.LEVEL_SET_DATA:
      return {
        ...state,
        level: action.level,
        error: false,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };

    case actionType.LEVEL_FAIL_DATA:
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.LEVEL_LOADING:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case actionType.LEVEL_POST_LOADING:
      return {
        ...state,
        isPostLoading: true,
        error: false,
      };
    case actionType.LEVEL_UPDATE_LOADING:
      return {
        ...state,
        isUpdateLoading: true,
        error: false,
      };
    case actionType.POST_LEVEL_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.POST_LEVEL_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        postLevel: action.postLevel,
      };
    case actionType.UPDATE_LEVEL_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_LEVEL_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_LEVEL_DATA_START:
      return {
        ...state,
      };

    default:
      return state;
  }
};
